<template>
  <div class="share-box">
    <van-nav-bar
      title="复制链接"
      left-text="返回"
      left-arrow
      @click-left="$router.go(-1)"
    />
    <div class="share-body">
      <template v-if="user.id">
          <div class="estimate">奖励预估收益 {{ promotion_rate }} 元</div>
      </template>
      <template v-else>
        <router-link class="c-red" :to="'/login?redirect='+$route.fullPath">登录</router-link>后才能获取佣金
      </template>
       <textarea class="content" :value="shareText" disabled> </textarea>
    </div>

    <div class="share-footer">
      <div class="share-footer-layer">
        <van-button
          type="warning"
          round
          size="large"
          @click="copy(shortLink)"
          >复制链接</van-button
        >
        <van-button type="warning" round size="large" @click="copy(shareText)"
          >分享素材</van-button
        >
        <van-button type="danger" round size="large" @click="go()"
          >前往购买</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      shortLink:'',
      goodInfo: {
        commodityInfo:{},
        couponInfo:{},
      }, //商品详情
    };
  },
   created() {
    // 商品详情
    this.Post(
      {
         id: this.$route.query.id,
         code:this.$route.query.code
      },
      "/sunning/commoditydetail", (res) => {
          if (res.states == 1) {
        let Data =  res.data.sn_responseContent.sn_body.queryCommoditydetail[0] || {};
        this.goodInfo = Data;
        this.getLink();
         } 
      })
  },
  computed: {
    ...mapState(["rate", 'user']),
    shareText() {
      const text = `
${this.goodInfo.commodityInfo.commodityName} \n
【到手价】: ${this.goodInfo.arrivalPrice}元 \n
下单链接:${this.shortLink}
`;
      return text;
    },
    // 佣金折算
    promotion_rate() {
      return (
        ((this.goodInfo.promotion_rate / 1000) *
          (this.goodInfo.min_normal_price / 100) *
          this.rate) /
        100
      ).toFixed(2);
    },
  },
  methods: {
    // 获取推广链接
    getLink(){
 //  生成推广链接
      this.Post({ 
productUrl:this.goodInfo.commodityInfo.productUrl,
quanUrl: this.goodInfo.couponInfo.couponUrl,
       }, "/sunning/extensionlink", (res) => {
      if (res.states == 1) {
        this.shortLink = res.data.sn_responseContent.sn_body.getExtensionlink.shortLink || '';
      }
       });
    },
    go() {
      window.location.href = this.shortLink;
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import "../../assets/less/share.less";
</style>



// WEBPACK FOOTER //
// src/pages/sunning/share.vue